import {carouselRef} from '../services/database'

export function getCarousel() {
  let res = []
  return carouselRef.get()
    .then(snaps => {
      snaps.forEach(snap => res.push(snap.data()))
      return res
    })
}